<template>
  <el-dialog title="新增字典" :visible.sync="dialogVisible" width="540px">
    <el-form :rules="create_rules" ref="createForm" :model="fd"
             label-position="left" label-width="80px" class="mx-30">
      <el-form-item prop="type" label="字典类型">
        <el-input v-model="fd.type" placeholder="如：ship.type" autoComplete="on"></el-input>
      </el-form-item>
      <el-form-item prop="code" label="代码">
        <el-input v-model="fd.code" placeholder="如：cargo" autoComplete="on"></el-input>
      </el-form-item>
      <el-form-item prop="value" label="名称">
        <el-input v-model="fd.value" placeholder="如：货船" autoComplete="on"></el-input>
      </el-form-item>
      <el-form-item prop="order" label="排序">
        <el-input-number v-model="fd.order" :min="0" controls-position="right"></el-input-number>
      </el-form-item>
    </el-form>
    <el-form class="mx-30">
      <el-form-item prop="op">
        <span style="float: right">
          <el-button size="small" @click="cancelData">取消</el-button>
          <el-button v-if="is_superuser"
                     type="primary" size="small"
                     @click="createData">保存</el-button>
        </span>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>
<script>
  import {createDict} from '@/api/dict'

  export default {
    name: 'dict-dialog',
    data() {
      return {
        dialogVisible: false,
        is_superuser: false,
        fd: {
          type: '',
          code: '',
          value: '',
          order: 99
        },
        create_rules: {
          type: [{required: true, message: '字典类型不能为空', trigger: 'blur'}],
          code: [{required: true, message: '代码不能为空', trigger: 'blur'}],
          value: [{required: true, message: '名称不能为空', trigger: 'blur'}]
        }
      }
    },
    methods: {
      resetFD() {
        this.fd = {
          type: '',
          code: '',
          value: '',
          order: 99
        }
      },
      handleCreate() {
        this.resetFD()
        this.dialogVisible = true
      },
      cancelData() {
        this.resetFD()
        this.dialogVisible = false
        this.$nextTick(() => {
          if (this.$refs.createForm) {
            this.$refs.createForm.clearValidate()
          }
        })
      },
      createData() {
        this.$refs['createForm'].validate(valid => {
          if (valid) {
            createDict(this.fd)
              .then(res => {
                this.$message.success(`创建字典成功, id=${res.id}`)
                this.$nextTick(() => {
                  this.dialogVisible = false
                  this.resetFD()
                  this.$refs['createForm'].clearValidate()
                  this.$emit('updateList')
                })
              })
              .catch(error => {
                this.$error_message(error)
              })
          }
        })
      }
    },
    created() {
      this.is_superuser = this.$store.getters.is_superuser
    }
  }
</script>
